module.exports = __webpack_public_path__ + "assets/img/index-partner31.62c7a497.jpg";